module.exports = __webpack_public_path__ + "static/media/2.d38b7b11.png";